$(function() {
    $.ajax({
        url: "/featured-places",
        method: "post",
        data: {}
    }).done(function (result) {
        $("#featured-places").html(result);
    });
});